<template>
  <el-dialog
      :visible="showDialog"
      :title="title"
      :width="width"
      :custom-class="customClass"
      append-to-body
      :close-on-click-modal="false"
      :show-close="showClose"
      @close="closeDialog"
  >
    <slot />
    <div v-if="showFooter" slot="footer" class="footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="confirmLoading" :disabled="confirmDisable" @click="confirmDialog">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'GjwDialog',
  props: {
    title: String,
    showDialog: {
      type: Boolean,
      required: true
    },
    confirmDisable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '640px'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    confirmDialog() {
      this.$emit('confirm')
    },
  }
}
</script>

<style scoped>

</style>
